import { render, staticRenderFns } from "./EmailAskManage.vue?vue&type=template&id=004ce825&"
import script from "./EmailAskManage.vue?vue&type=script&lang=js&"
export * from "./EmailAskManage.vue?vue&type=script&lang=js&"
import style0 from "./EmailAskManage.vue?vue&type=style&index=0&id=004ce825&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004ce825')) {
      api.createRecord('004ce825', component.options)
    } else {
      api.reload('004ce825', component.options)
    }
    module.hot.accept("./EmailAskManage.vue?vue&type=template&id=004ce825&", function () {
      api.rerender('004ce825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/asks/email-ask-manage/EmailAskManage.vue"
export default component.exports